<app-mini-layout-wrapper [showLogout]="!isEm">
  <div class="mini-layout__title">{{ reason.header }}</div>
  <div class="mini-layout__text">{{ reason.subheader }}</div>
</app-mini-layout-wrapper>
